import http from "../services/http";
import { __api_updateOperationInfo,__api_getDailyWorkYearOrMonth } from "./endpoints";

export const updateOperationInfo = data => {
    return http.Request("POST", __api_updateOperationInfo, data);
}

export const getDailyWorkYearOrMonth = (req) => {
    return http.Request("GET", [__api_getDailyWorkYearOrMonth + "/" + req.machineSaleId,req.qs].join("?"));
}